// Family Repository - Repository Pattern
import apiService from '../api.service';

class FamilyRepository {
  // Get all families
  async getAll() {
    return apiService.get('/families');
  }

  // Get single family
  async getById(id) {
    return apiService.get(`/families/${id}`);
  }

  // Create family
  async create(data) {
    return apiService.post('/families', data);
  }

  // Update family
  async update(id, data) {
    return apiService.patch(`/families/${id}`, data);
  }

  // Delete family
  async delete(id) {
    return apiService.delete(`/families/${id}`);
  }
}

export default new FamilyRepository();
